import { useEffect, useState } from 'react';
import { Communication, CommunicationRecipient } from 'types/Communication';
import { updateRecipients } from 'modules/communications/components/utils';

type UseGetRecipientsDataProps = {
  communication: Communication | null;
};

export const useGetRecipientsData = ({
  communication,
}: UseGetRecipientsDataProps) => {
  const [recipients, setRecipients] = useState<CommunicationRecipient[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchRecipients = async () => {
      if (!communication) return;
      try {
        setIsLoading(true);
        const recipientsInfo = await updateRecipients(communication);
        setRecipients(recipientsInfo);
      } catch (error) {
        console.error(error); // eslint-disable-line
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecipients();
  }, [communication]);

  return {
    data: {
      recipients,
    },
    isLoading,
  };
};
